<template>
	<div style="background:transparent;box-shadow: none;padding: 0;" v-loading="loading">
		<sbspSalaryFilter :filterList.sync="filterList">
			<el-form-item label="工资月份：" style="margin-right:60px;">
				<div style="display: flex;align-items: center;">
					<el-select v-model="filterList[0].value" placeholder="请选择" style="width:110px;" @change="dateWageChange()">
						<el-option v-for="item in filterList[0].options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
          <el-date-picker class="el-date" v-if="filterList[0].value=='92480004'" v-model="wageTime.month"  style="width:230px;margin-left:4px;"
                          type="monthrange"
                          range-separator="至"
                          value-format="yyyy-MM"
                          start-placeholder="开始月份"
                          end-placeholder="结束月份">
          </el-date-picker>
				</div>
			</el-form-item>
		</sbspSalaryFilter>
		<div class="carBox" ref="carBox" >
			<div v-if="cardDatas.length== 0&&showNodata" style="margin: 0 auto;">
				<noData style="margin-top: 200px;" msg="暂无数据"></noData>

			</div>
			<card v-for="(cardData,i) in cardDatas" :key="cardData.id"  :cardData="cardData" @toParent="replaceData" :index="i" :labels='labels'>
				<div class="leftButtonCon">
					<leftButton title="查看详情" @click="details(cardData)" style="top:15px;"></leftButton>
				</div>
			</card>
		</div>
		<p class="more">
			<span @click="moreData()" v-if="cardDatas.length==this.msgPage.limit">查看更多></span>
		</p>
	</div>

</template>

<script>
	import sbspSalaryFilter from "@/wage-components/sbs-salary-filter/sbsp-salary-filter.vue"
  import card from "@/wage-components/sbs-salary-card/card.vue"
  import noData from "@/wage-components/bsp-noData/bsp-noData.vue"
	import leftButton from "@/wage-components/sbs-salary-card/left-button.vue"
	import {
		approvalDetails
	} from "@/api/wage/approval.js"
  import {
    queryPmsPayGroupTree
  } from "@/api/wage/payGroup";
	export default {
		name: "approval",
		components: {
			sbspSalaryFilter,
      card,
      noData,
			leftButton
		},
		data() {
			return {
				msgPage: {
					limit: 6,
					page: 1,
					total: 0,
          monthStr:'92480001',
          monthStart:'',
          monthEnd:'',
          batchId:'',
        },
				loading:false,
				showNodata:false,
        wageTime:{
          month:'',
        },
				labels: ["发薪人数", "社保月份", "发薪金额", "税金月份", "工资审批单"],
				cardDatas: [],
        params: { //下拉框传参对象
          filterTextValue: "",
          filterOptionValue: ""
        },
        filterList: [
          { text: "工资月份", type: 'select-timer',value:'92480002',name:'wageMonth',
            options:[{
              value: '92480001',
              label: '当前月'
            }, {
              value: '92480002',
              label: '近三个月'
            }, {
              value: '92480003',
              label: '近一年'
            },{
              value: '92480004',
              label: '其他'
            }
            ]
          },
          // { text: "批次名称", type: 'text',value:'',name:'batchName'},
          { text: "", type: 'text',value:'',name:'batchName'},
          { text: "薪酬组", type: 'treeSelect',value:[],multiple:true,name:'groupId',
            defaultGroupProps:{
              children: 'children',
              label: 'groupName',
              value: 'id',
            },
            options: []
          },
          {
            text: "社保月份",
            type: 'timer',
            value: '',
            name: 'socMonth',
            format: 'yyyy-MM',
            pickerType: 'month'
          },
          {
            text: "税金月份",
            type: 'timer',
            value: '',
            name: 'taxMonth',
            format: 'yyyy-MM',
            pickerType: 'month'
          },
          { text: "计税类型", type: 'select',value:[],multiple:true,name:'taxType',dicts:'9245',remNum:"92450002,92450004,92450007"}
        ]

			};
		},
    watch:{
      filterList:{//深度监听，可监听到对象、数组的变化
        handler(val, oldVal){
          val.map((item)=>{
            if(item.value2){
              this.$set(this.msgPage,item.name,item.value2);
            }else{
              if(item.value2==''&&item.value){
                this.$set(this.msgPage,item.name,item.value.split(','));
              }else{
                this.$set(this.msgPage,item.name,item.value);
              }
            }
          })
          this.$set(this.msgPage,'page',1);
          if(this.msgPage.wageMonth=='92480004'){
            return ;
          }
          this.approvalDetails(true);
        },
        deep:true //true 深度监听
      },
      wageTime:{
        handler(val, oldVal){

          let month = val.month;
          this.$set(this.msgPage,'monthStart',month[0]);
          this.$set(this.msgPage,'monthEnd',month[1]);
          this.approvalDetails(true);
        },
        deep:true //true 深度监听
      }
    },
		created() {
			this.filterLists = JSON.parse(JSON.stringify(this.filterList))
			this.approvalDetails(true);
      this._queryPmsPayGroupTree() //查询薪酬组树
		},
		mounted() {
			window.addEventListener('scroll', () => {
			  if(this.$refs.carBox&&this.cardDatas.length!=this.msgPage.limit){
          var top = this.$refs.carBox.getBoundingClientRect().top;
          var height = this.$refs.carBox.clientHeight;
          console.log(top + height - document.getElementsByClassName('main')[0].clientHeight)
          if (top + height - document.getElementsByClassName('main')[0].clientHeight < 60) {
            this.moreData();
          }
        }
			}, true);
		},
		methods: {
      replaceData(i,data){
        this.cardDatas.splice(i,1,data);
        console.log(this.cardDatas)
      },
      dateWageChange(val){
        if(this.filterList[0].value!='92480004'){
          this.$set(this.msgPage,'monthStart','');
          this.$set(this.msgPage,'monthEnd','');
        }
      },
			approvalDetails(reload) {
				this.loading = true;
				let batchId = this.$route.query.batchId;
				;
				if(batchId!=undefined){
          this.$set(this.msgPage,'batchId',batchId);
        }
        approvalDetails(this.msgPage).then(res => {
          if (res.data.data.length < this.msgPage.limit) {
            this.isBottom = true;
          }else {
            this.isBottom = false;
          }
          if(reload){
            this.cardDatas = res.data.data;
          }else {
            this.cardDatas = this.cardDatas.concat(res.data.data);
          }
					this.showNodata = true;
					this.loading = false;

				});
			},
      //获取薪酬组数据
      _queryPmsPayGroupTree() {
        queryPmsPayGroupTree().then(res => {
          let rs = res.data
          if (rs.code == 0) {
            // this.filterList[2].value = [rs.data[0].id]
            this.filterList[2].options = rs.data;
            // console.log(rs.data,222222222222222)
            this.filterLists = JSON.parse(JSON.stringify(this.filterList));
          }
        })
      },
			moreData() {
				if (this.isBottom) {
					return;
				}
				this.$set(this.msgPage, 'page', this.msgPage.page + 1);
				this.approvalDetails(false);
			},
      details(item){
        const query = {
          templateId: item.tmpId,
          batchId: item.id,
          region:'',
          orgId:'',
          payGroupId:'',
          wageMonth:item.wageMonth,
          socMonth:item.info.num2,
          taxMonth:item.info.num4,
          isHistoryFlag:''
        }
        this.$router.push({
          path: '/wage/salaryDetailTabs',
          query
        });
      },
		}
	};
</script>

<style scoped>
	.el-date.el-date-editor >>> 	 .el-range__close-icon{
			line-height: 20px;
		}
  .carBox {
		display: flex;
		flex-wrap: wrap;
	}

	.more span {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(64, 158, 255, 1);
		line-height: 18px;
		cursor: pointer;
	}

	.more {
		text-align: right;
	}

	.more span:hover {
		text-decoration: underline;

	}
</style>
